import type { Filesystem } from '@gitbook/openapi-parser';

/**
 * Check if the value is a valid OpenAPI filesystem.
 */
export function checkIsValidFilesystem(value: unknown): value is Filesystem {
    if (!Array.isArray(value)) {
        return false;
    }

    if (value.length === 0) {
        return false;
    }

    return true;
}
